import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { ProgramCaps } from '../components/program-cap/program-caps';
import { DynamicDrawerProvider } from '../context/dynamic-drawer.context';

const ProgramCapsPage = (): JSX.Element => (
  <DynamicDrawerProvider>
    <HHStack
      flex={1}
      gap={4}
      spacing={4}
      sx={{ marginTop: 4, overflow: 'hidden' }}
    >
      <HHStack sx={{ margin: 4 }}>
        <HHTypography hhVariant="section-title">Program Caps</HHTypography>
      </HHStack>
      <ProgramCaps />
    </HHStack>
  </DynamicDrawerProvider>
);

export default ProgramCapsPage;
